import React, { useEffect, useState } from 'react'
import { Button, Modal, Form, Toast } from '@themesberg/react-bootstrap'
import {
  PERMISSION_MODULES,
  flagsToPermission,
  permissionToFlags,
} from '../../../../helper/adminSession'

const emptyFlags = () => ['0', '0', '0', '0', '0']

export default function AdminFormModal({ show, mode, admin, onHide, onSubmit }) {
  const isEdit = mode === 'edit'

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [name, setName] = useState('')
  const [flags, setFlags] = useState(emptyFlags())
  const [makeSuperAdmin, setMakeSuperAdmin] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!show) return
    setError('')
    setPassword('')
    if (isEdit && admin) {
      setEmail(admin.email || '')
      setName(admin.name || '')
      setFlags(permissionToFlags(admin.permission))
      setMakeSuperAdmin(admin.isSuperAdmin === 1)
    } else {
      setEmail('')
      setName('')
      setFlags(emptyFlags())
      setMakeSuperAdmin(false)
    }
  }, [show, isEdit, admin])

  const onFlagChange = (index, checked) => {
    const next = [...flags]
    next[index] = checked ? '1' : '0'
    setFlags(next)
  }

  const handleSubmit = async () => {
    setError('')
    if (!isEdit && (!email || !password || password.length < 6)) {
      setError('Email và mật khẩu (tối thiểu 6 ký tự) là bắt buộc')
      return
    }

    const payload = {
      name: name || null,
      permission: flagsToPermission(flags),
    }

    if (!isEdit) {
      payload.email = email
      payload.password = password
      payload.status = 1
    } else {
      payload.id = admin.id
      if (makeSuperAdmin && admin.isSuperAdmin !== 1) {
        if (!window.confirm('Thêm quyền super admin cho tài khoản này?')) {
          return
        }
        payload.isSuperAdmin = 1
      }
    }

    const result = await onSubmit(payload)
    if (result?.error) {
      setError(result.message || 'Có lỗi xảy ra')
      return
    }
    onHide(true)
  }

  return (
    <Modal show={show} onHide={() => onHide(false)} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Sửa quản trị viên' : 'Thêm quản trị viên'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Toast show className="d-block mb-3" bg="danger">
            <Toast.Body className="text-white">{error}</Toast.Body>
          </Toast>
        )}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              disabled={isEdit}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          {!isEdit && (
            <Form.Group className="mb-3">
              <Form.Label>Mật khẩu</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={6}
                required
              />
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Tên hiển thị</Form.Label>
            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Quyền module</Form.Label>
            {PERMISSION_MODULES.map((mod) => (
              <Form.Check
                key={mod.index}
                type="checkbox"
                id={`perm-${mod.index}-${mode}`}
                label={mod.label}
                checked={flags[mod.index] === '1'}
                onChange={(e) => onFlagChange(mod.index, e.target.checked)}
              />
            ))}
          </Form.Group>
          {isEdit && admin?.isSuperAdmin !== 1 && admin?.status === 1 && (
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="make-super-admin"
                label="Chuyển thành super admin"
                checked={makeSuperAdmin}
                onChange={(e) => setMakeSuperAdmin(e.target.checked)}
              />
            </Form.Group>
          )}
          {isEdit && admin?.isSuperAdmin === 1 && (
            <p className="text-muted small mb-0">Tài khoản super admin</p>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Đóng
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {isEdit ? 'Lưu' : 'Thêm'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
